import * as React from 'react';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { usePartnerContext } from '../../components/Context/PartnerContext';
import { useNavigate } from 'react-router-dom';

const columns= [
  {
    field: 'link',
    headerName: 'Link',
    width: 50,
    renderCell: (params) => (
      // <a href={`https://example.com/posts/${params.id}`} target="_blank" rel="noopener noreferrer">
        <i className="bi bi-info-circle" ></i>
      // </a>
    ),
  },
  { field: 'name', headerName: 'Name', width: 150 },
  { field: 'email', headerName: 'Email', width: 150 },
  { field: 'phone', headerName: 'Phone', width: 150 , sortable: false},
  { field: 'position', headerName: 'Position', width: 150 },
  { field: 'specialization', headerName: 'specialization', width: 150 },
  { field: 'branchName', headerName: 'Branch Name', width: 150 }
  
];

export default function EmployeeTable() {
   
  const { embployee } = usePartnerContext();
    const navigate = useNavigate();
  const filterColumns = ({ field, columns, currentFilters }) => {
    // remove already filtered fields from list of columns
    const filteredFields = currentFilters?.map((item) => item.field);
    return columns
      .filter(
        (colDef) =>
          colDef.filterable &&
          (colDef.field === field || !filteredFields.includes(colDef.field)),
      )
      .map((column) => column.field);
  };

  const getColumnForNewFilter = ({ currentFilters, columns }) => {
    const filteredFields = currentFilters?.map(({ field }) => field);
    const columnForNewFilter = columns
      .filter(
        (colDef) => colDef.filterable && !filteredFields.includes(colDef.field),
      )
      .find((colDef) => colDef.filterOperators?.length);
    return columnForNewFilter?.field ?? null;
    };
    const CustomToolbar = (props) => (
        <GridToolbarContainer>
            <EditToolbar {...props} />
            <GridToolbar />
        </GridToolbarContainer>
    );
    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;

        const handleClick = () => {
            handleAddBranch();
            
        };
        const handleAddBranch = () => {
            navigate('/employeeadd');
        };
        return (
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    New Employee
                </Button>
            </GridToolbarContainer>
        );
    }
    const handleRowClick = (params) => {
        // Navigate to the edit form with the branch ID
        navigate(`/editemployee/${params.id}/false`, { state: { embployee: params.row } });
    };

  return (
      <div style={{ height: '100%', width: '100%' }}>
      <DataGrid rows={embployee} columns={columns} 
              slots={{ toolbar: CustomToolbar }}
              onRowClick={handleRowClick} // Add this line to handle row clicks
      slotProps={{
        filterPanel: {
          filterFormProps: {
            filterColumns,
          },
          getColumnForNewFilter,
        },
      }}
      />
    </div>
  );
}